import { render, staticRenderFns } from "./MyAccountPage.vue?vue&type=template&id=b4146446&scoped=true"
import script from "./MyAccountPage.vue?vue&type=script&lang=js"
export * from "./MyAccountPage.vue?vue&type=script&lang=js"
import style0 from "./MyAccountPage.vue?vue&type=style&index=0&id=b4146446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4146446",
  null
  
)

export default component.exports